export class ConnectRestoreAccountRequest {
    'name';
    'restoreAccountAttributes';
    'isInternalAccount';
    'tags';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreAccountAttributes",
            "baseName": "restoreAccountAttributes",
            "type": "RestoreAccountAttributesInput",
            "format": ""
        },
        {
            "name": "isInternalAccount",
            "baseName": "isInternalAccount",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectRestoreAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
